// extracted by mini-css-extract-plugin
export default {"settingsLink":"N8wJeIdwgfOIQFlF7zji"};